<template>
    <div>
        <div class="login-form">
            <form @submit.prevent="login">
                <b-alert :show="error" variant="danger" class="text-center" dismissible @dismissed="error = false">
                    Incorrect email address or password
                </b-alert>
                <b-form-group class="mb-1 username">
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <font-awesome-icon :icon="['fad', 'envelope']" fixed-width />
                        </b-input-group-prepend>
                        <b-form-input
                            id="backstage-email"
                            type="text"
                            placeholder="Email Address"
                            aria-label="email"
                            v-model="user.email"
                            :class="{'is-invalid': validating && !user.email}"
                            autofocus
                        />
                    </b-input-group>
                    <small class="form-text text-danger mb-3" v-if="validating && !user.email">
                        Email address is required.
                    </small>
                </b-form-group>

                <b-form-group class="password">
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <span v-if="user.password">
                                <font-awesome-icon :icon="['fad', 'unlock']" fixed-width />
                            </span>
                            <span v-else>
                                <font-awesome-icon :icon="['fad', 'lock']" fixed-width />
                            </span>
                        </b-input-group-prepend>
                        <b-form-input
                            id="backstage-password"
                            type="password"
                            placeholder="Password"
                            aria-label="password"
                            v-model="user.password"
                            :class="{'is-invalid': validating && !user.password}"
                        />
                    </b-input-group>
                    <small class="form-text text-danger" v-if="validating && !user.password">Password is
                        required.</small>
                </b-form-group>

                <b-btn
                    type="submit"
                    variant="primary"
                    class="text-uppercase"
                    :disabled="logging_in"
                    block
                >
                    <span v-if="logging_in">
                        <b-spinner label="Spinning" small></b-spinner>
                    </span>
                    <span v-else>
                        <font-awesome-icon :icon="['fad', 'sign-in']" fixed-width /> Log In
                    </span>
                </b-btn>
            </form>
        </div>
    </div>
</template>

<style lang="scss" scoped></style>

<script>
import {mapState} from 'vuex'

export default {
    data: () => ({
        user: {},

        logging_in: false,
        error: false,
    }),
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        })
    },
    props: [],
    methods: {
        login() {
            this.$store.commit('setValidating', true)

            if (!this.validLogin()) {
                return false
            }

            this.logging_in = true

            this.axios.post('/api/login', {
                email: this.user.email,
                password: this.user.password
            }).then(() => {
                this.logging_in = false
                this.error = false

                this.$emit('login')
            }).catch(error => {
                if (error) {
                    this.logging_in = false

                    if (
                        error.response &&
                        error.response.status == 404
                    ) {
                        this.error = true
                    } else {
                        this.$bvToast.toast(error.message, {
                            variant: 'danger',
                            solid: false,
                            autoHideDelay: 5000,
                            appendToast: true
                        })
                    }
                }
            })
        },
        validLogin() {
            let valid = true

            if (
                this.user.email === '' ||
                this.user.password === ''
            ) {
                valid = false
            }

            return valid
        }
    }
}
</script>
